import { singletonMap } from "../../SingletonMap/SingletonMap/SingletonMap.js";
const reducersMap = singletonMap("reducers");
let listener;
const ReducersRegistry = {
  get reducers() {
    return {
      ...reducersMap
    };
  },
  set listener(l) {
    listener = l;
  },
  register(name, reducer) {
    reducersMap[name] = reducer;
    if (listener) {
      listener({
        ...reducersMap
      });
    }
  }
};
export {
  ReducersRegistry
};
//# sourceMappingURL=ReducersRegistry.js.map
